// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'da84c3d5e4d9760ef9cd57f740655a227d76d0c1';
export const BUILD_NUMBER = '185';
export const BUILD_TIMESTAMP = '2026-07-02T03:54:06.006Z';
